import React from "react";
import moment from 'moment';
import { toast, } from 'react-toastify';
import axios from 'axios'
import ReactTable from 'react-table-v6'
import '../../assets/css/Table.css'
import { NavLink } from 'react-router-dom';
import RegularButton from "../../components/CustomButtons/Button.jsx";
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import EditIcon from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import GridContainer from "../Grid/GridContainer.jsx";
import GridItem from "../Grid/GridItem.jsx";
import Grid from '@material-ui/core/Grid'
import Card from "../Card/Card.jsx";
import CardBody from "../Card/CardBody.jsx";
import CardHeader from "../Card/CardHeader.jsx";
import { cardTitle } from "../../assets/jss/material-dashboard-pro-react.jsx";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExportTo from '../Common/ExportTo'
import CustomDialog from '../Common/CustomDialog'
import { BASE_URL } from "../../utils/handleApi";

const styles = theme => ({
  cardIconTitle: {
    ...cardTitle,
    marginTop: "6px",
    marginBottom: "0px"
  },
});
class ReactTables extends React.Component {
  state = {
    loading : false,
    arrRespInputs: [],
    showDialogForDelete : false,
    openDialogWhenNoData: false
  };
   
  componentDidMount() {
    let tokenStr = localStorage.getItem('token')
    this.setState({loading : true})
    axios.post(`${BASE_URL}/product/details`, {
      "product_id": this.props.productId
    },{
      headers: {
        'Authorization': `Bearer ${tokenStr}`
      }
    })
    .then(res => {
      const tempResInputs = res.data.inputs.map(resinput => (
        {
          id: resinput._id,
          name: resinput.input_data,
          actions: (
            <div className="actions-right">
              <NavLink to={{ 
                pathname: `/MyLenders/products/${this.props.lenderId}/responseInputs/${this.props.productId}/edit/${resinput._id}`, 
                state: {
                  lender_name: this.props.lenderName
                }
              }}>
                <Button
                  color="default"
                  className="Edit"
                >
                  <Tooltip title="Edit">
                    <EditIcon /> 
                  </Tooltip>
                </Button>{" "}
              </NavLink>
              <Button
                onClick={() => this.setState({ showDialogForDelete: true, idToDelete: resinput._id })}
                className="remove"
              >
                <Tooltip title="Delete"> 
                  <Close />
                </Tooltip>
              </Button>{" "}
            </div>
          )}
        ))
        tempResInputs.reverse();
        this.setState({
          arrRespInputs : tempResInputs,
          loading : false
        })
      })
    .catch(() => {
      this.setState({ loading: false })
      toast.error('Some error happened!')
    })
  }

  handleYes = () => {
    const { idToDelete, arrRespInputs } = this.state;
    const tokenStr = localStorage.getItem('token');
    axios.post(`${BASE_URL}/product/deleteResponseInput`, {
      'product_id': this.props.productId,
      'input_id': idToDelete
    },{
      headers:{
        'Authorization': `Bearer ${tokenStr}`,
      }
    })
    .then(() => {
      let respInputs = arrRespInputs;
      respInputs = respInputs.filter(resinput => resinput.id !== idToDelete);
      this.setState({
        arrRespInputs: respInputs, 
        showDialogForDelete: false 
      }, () => {
        toast.success('Response Input deleted successfully!')
      });
    })
    .catch(() => {
      toast.error('Some error happened!')
    })
  }

  exportPDF = () => {
    const { arrRespInputs, openDialogWhenNoData } = this.state;
      if(arrRespInputs.length === 0){
        return this.setState({ openDialogWhenNoData: !openDialogWhenNoData })
      }
      else {
        const unit = "pt";
        const size = "A4";
        const orientation = "landscape";

        const marginLeft = 20;
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(15);

        const title = "My Response Inputs";
        const headers = [["Name" ]];

        const data = arrRespInputs.map((prop, key) => ([
            prop.name
        ]))

        let content = {
          startY: 50,
          head: headers,
          body: data
        };

        doc.text(title, marginLeft, 40);
        doc.autoTable(content);
        doc.save(`response_inputs_${moment().format('LLL')}`)
      }
  }

  exportExcel = () => {
    if(this.state.arrRespInputs.length === 0){
      this.setState({ openDialogWhenNoData: !this.state.openDialogWhenNoData });
      return false
    }
    return true
  }

  render() {
    const { loading, arrRespInputs, showDialogForDelete, openDialogWhenNoData } = this.state;
    const { classes } = this.props;

    const dataExcel = arrRespInputs.map((prop, key) => {
        return {
            Name: prop.name
        };
    })
    
    return (
      <GridContainer style={{width:'83vw'}}>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="rose" icon>
              <div className={classes.cardIconTitle}>
                <Grid item>
                  <ExportTo 
                    fileName={'response_inputs'}
                    exportPDF={this.exportPDF}
                    exportExcel={this.exportExcel}
                    dataExcel={dataExcel}
                  />
                </Grid>
              </div>
            </CardHeader>
            <CardBody>
              <ReactTable
                loading={loading}
                NoDataComponent={() => !loading && <p style={{textAlign: "center", margin: "10px 0"}}>No Response Input available</p>}
                data={arrRespInputs}
                filterable
                columns={[
                  {
                      Header: "Name",
                      accessor: "name"
                  },
                  {
                      Header: "Actions",
                      accessor: "actions",
                      sortable: false,
                      filterable: false,
                      headerStyle: { textAlign: 'center' },
                      width: 150,
                  }
                ]}
                style={{ width: '99%', border: 'none', whiteSpace: 'unset', marginLeft: 'auto', marginRight: 'auto' }}
                defaultPageSize={10}
                minRows={0}
                showPaginationTop
                showPaginationBottom={false}
                className="-striped -highlight"
                getTrGroupProps={() => {
                    return {
                        style: {
                            borderBottom: "1px solid #d6d6d6",
                        }
                    }
                }}
                getPaginationProps={() => { return { style: { boxShadow: 'none', border: 'none', } } }}
              />
            </CardBody>
          </Card>
        </GridItem>
        <Dialog
          className={classes.dialog}
          open={showDialogForDelete}
          onClose={() => this.setState({ showDialogForDelete: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{backgroundColor: "green", fontSize: "18px", color: "white"}}>
            <p style={{color: "white"}}>   Please Confirm </p></DialogTitle>
          <DialogContent style={{marginTop: "10px"}}>
            Are you sure you want to <b>delete this Response Input?</b>
          </DialogContent>
          <DialogActions>
            <RegularButton onClick={() => this.setState({ showDialogForDelete: false })} color="danger" >
            No
            </RegularButton>
            <RegularButton onClick={this.handleYes} color="success" autoFocus>
            Yes
            </RegularButton>
          </DialogActions>
        </Dialog>
        <CustomDialog 
          openDialog={openDialogWhenNoData}
          closeDialog={() => this.setState({ openDialogWhenNoData: !openDialogWhenNoData })}
        />
      </GridContainer>
    );
  }
}

export default withStyles(styles)(ReactTables);